import thumbsArr from "../assets/ThumbsImport.js"
import GalleriesArr from "../assets/GalleryImport.js"

let productsArr = [
    {   
        id: 1,
        title: "silla de comedor mid-century",
        alt: "silla de madera",
        thumb: [thumbsArr[0]],
        price: "$1,400 MXN",
        style: "escandinavo",
        materials: "madera maciza (cedro), asiento tapizado en tela y patas de bronce",
        year: "circa 1960",
        measurements: "94cm (altura) 43cm (altura al asiento) 44cm (profundidad y ancho)",
        gallery: GalleriesArr[0],
    },
    {   
        id: 2,
        title: "sillón ramírez vázquez",
        alt: "silla de madera",
        thumb: [thumbsArr[1]],
        price: "6,990 MXN",
        style: "escandinavo",
        materials: "madera maciza (cedro), asiento tapizado en tela y patas de bronce",
        year: "circa 1960",
        measurements: "94cm (altura) 43cm (altura al asiento) 44cm (profundidad y ancho)",
        gallery: GalleriesArr[1],
    },
    {   
        id: 3,
        title: "mesa de centro mid-century",
        alt: "mesa de centro",
        thumb: [thumbsArr[2]],
        price: "4,500 MXN",
        style: "escandinavo",
        materials: "madera maciza (caoba)",
        year: "circa 1960",
        measurements: "121cm (largo) 48cm (ancho) 37.5cm (alto)",
        gallery: GalleriesArr[2],
    },
    {   
        id: 4,
        title: "mesa de noche dixy",
        alt: "mesa de noche",
        thumb: [thumbsArr[3]],
        price: "2,190 MXN",
        style: "art-decó",
        materials: "chapado en madera de caoba, patas de caoba maciza, y jaladera de bronce",
        year: "circa 1960",
        measurements: "59cm (alto) 35cm (profundidad) 56cm (ancho)",
        gallery: GalleriesArr[3],
    },
    {   
        id: 5,
        title: "carrito de servicio",
        alt: "carrito de servicio",
        thumb: [thumbsArr[4]],
        price: "2,190 MXN",
        style: "mid-century modern",
        materials: "patas de madera maciza y estantes chapados en caoba",
        year: "circa 1960",
        measurements: "80cm (largo) 48cm (diámetro)",
        gallery: GalleriesArr[4],
    },
    {   
        id: 6,
        title: "esquinero de metal",
        alt: "esquinero de metal",
        thumb: [thumbsArr[5]],
        price: "4,990 MXN",
        style: "art-decó",
        materials: "hierro con acentos de bronce y estantes de vidrio",
        year: "circa 1960",
        measurements: "117cm (alto) 51cm (lados)",
        gallery: GalleriesArr[5],
    },
    {   
        id: 7,
        title: "sillón ramírez vázquez",
        alt: "silla de madera",
        thumb: [thumbsArr[6]],
        price: "6,990 MXN",
        style: "escandinavo",
        materials: "madera maciza (cedro), asiento tapizado en tela y patas de bronce",
        year: "circa 1960",
        measurements: "94cm (altura) 43cm (altura al asiento) 44cm (profundidad y ancho)",
        gallery: GalleriesArr[6],
    },
    {   
        id: 8,
        title: "mesa de noche dixy",
        alt: "silla de madera",
        thumb: [thumbsArr[7]],
        price: "2,190 MXN",
        style: "escandinavo",
        materials: "madera maciza (cedro), asiento tapizado en tela y patas de bronce",
        year: "circa 1960",
        measurements: "94cm (altura) 43cm (altura al asiento) 44cm (profundidad y ancho)",
        gallery: GalleriesArr[7],
    }
]

export default productsArr